<script lang="ts">
    /**
 *
 *
 *
 *
 *
 *
 */
    import type { Attachment } from 'svelte/attachments';
    import { log } from '@shared/log.browser.ts';
    import type { ObserverCallback } from './TileObserver.browser.ts';

    interface Props {
        action: () => Promise<void>; /*                                            */
        successful: boolean; /*                                                                */
        cacheRestored: boolean; /*                                      */
        observe: (callback: ObserverCallback) => Attachment; /*                                        */
        onAttachment: (attachment: Attachment) => void; /*                                     */
    }

    let { action, successful, cacheRestored, observe, onAttachment }: Props = $props();

    /*                                                              */
    let tileObserved = $state(false);

    /**
 *
 *
 *
 *
 */
    const runAction = $derived(tileObserved && !successful && cacheRestored);

    $effect(() => {
        if (runAction) {
            action().catch((err) => {
                log.warn('Action failed:', err);
            });
        }
    });
    /**
 *
 */
    $effect(() => {
        onAttachment(observe((entry) => (tileObserved = entry.isIntersecting)));
    });
</script>
